import { ResTransactionDetail } from '@/types/transaction'
import { api } from '@/utils/api'
import { apiTransactionsId } from '@/utils/api/url'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { useQuery } from '@tanstack/react-query'
export const QUERY_KEY_DETAIL_APPOINTMENT = 'QUERY_KEY_DETAIL_APPOINTMENT'
export const useGetAppointmentDetail = ({
  id,
  branch,
  enabled = true,
}: {
  branch: string
  id: string
  enabled?: boolean
}) => {
  const transactionItems = useQuery({
    queryKey: [QUERY_KEY_DETAIL_APPOINTMENT, id, branch],
    queryFn: () =>
      api
        .get(createRouteForAPI(apiTransactionsId, { branch, id }))
        .then(({ data }) => data as ResTransactionDetail),
    enabled: !!id && !!branch && enabled,
  })
  return transactionItems
}
